import { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { getParcelasPagas, getNotaFiscal, getParcelasContrato } from 'api/clients';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelPagamento = (contratoId) => {
  const [mensalidades, setMensalidades] = useState([]);
  const [parcelas, setParcelas] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const searchMensalidades = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await getParcelasContrato(contratoId);
      setMensalidades(data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [contratoId]);

  const searchPagamentos = useCallback(async () => {
    setError(null);
    setLoading(true);
    try {
      const data = await getParcelasPagas(contratoId);
      setParcelas(data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [contratoId]);

  return {
    searchMensalidades,
    mensalidades,
    error,
    loading,
    searchPagamentos,
    parcelas,
    setLoading,
  };
};

export default useModelPagamento;
